export default __webpack_public_path__ + "static/media/chevron-right.0e8c803a.svg";